import { CheckboxContext, useCheckboxSelection } from "../Checkbox";
import { Menu, MenuItem } from "@mui/material";
import { useContext, useState } from "react";
import { useTableData } from "../../../../misc/scroller/Table";
import { logisticsTableName } from "./Logistics";
import { useProjectId } from "../ProjectName";
import { ArchiveItemsForm, canArchive } from "./ArchiveItemsForm";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function BulkArchive(props) {
    const sel = useCheckboxSelection();
    const setChecked = useContext(CheckboxContext).set;
    const [open, setOpen] = useState(false);
    const project = useProjectId();
    const data = useTableData(logisticsTableName(project, props.type));
    const values = data.filter(d => sel.indexOf(d.id) !== -1 && canArchive(d));
    return /*#__PURE__*/ _jsxs(_Fragment, { children: [/*#__PURE__*/ _jsx(MenuItem, { disabled: values.length === 0, onClick: () => { props.onOpen(); setOpen(true); }, children: "Archive" }), open && /*#__PURE__*/ _jsx(Menu, { open: true, anchorEl: props.anchorEl, onClose: () => setOpen(false), children: /*#__PURE__*/ _jsx(ArchiveItemsForm, { type: props.type, rows: values, onCancel: () => setOpen(false), onArchived: ids => {
                        ids.forEach(id => setChecked(id, false));
                        setOpen(false);
                    } }) })] });
}
